import { Injectable } from '@angular/core';
import { DialogService } from './dialog.service';
import { ConfirmComponent } from '../components/dialog/confirm/confirm.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorModalService {
  constructor(private dialogService: DialogService) {}

  // show a simple error dialog using your existing ConfirmComponent layout.
  // We pass firstButton/secondButton to match the template.
  showError(
    title: string,
    message: string,
    type: 'timeout' | 'network' | 'server' | 'request' = 'server',
    showRetry: boolean = true
  ): Observable<any> {
    const dialogRef =this.dialogService.open(ConfirmComponent, {
      data: {
        title,
        message,
        type,
        showRetry,
        firstButton: showRetry ? 'Försök igen' : 'OK',
        secondButton: 'Stäng',
        showCancel: showRetry
      }
    });
    return dialogRef.afterClosed;
  }
}
